import { createClient } from '@supabase/supabase-js';

// Khởi tạo Supabase client
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://aggkdikmvlbtaumbbszf.supabase.co';
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFnZ2tkaWttdmxidGF1bWJic3pmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTc5MDU3MzQsImV4cCI6MjAzMzQ4MTczNH0.GrDrkPMoTxZ_LCq9-TZDkzx2TnhA6g0DdP7f0YQSoFc';

export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: {
      getItem: (key) => {
        const value = localStorage.getItem(key);
        // console.log(`Getting from storage: ${key} = ${value ? 'exists' : 'missing'}`);
        return value;
      },
      setItem: (key, value) => {
        // console.log(`Setting to storage: ${key} = ${value ? 'value' : 'empty'}`);
        localStorage.setItem(key, value);
      },
      removeItem: (key) => {
        // console.log(`Removing from storage: ${key}`);
        localStorage.removeItem(key);
      }
    }
  },
});

// Thêm event listener cho session changes
supabase.auth.onAuthStateChange((event, session) => {
  console.log('Auth state changed:', event);
  
  if (event === 'SIGNED_IN' && session) {
    console.log('User signed in, storing tokens');
    localStorage.setItem('token', session.access_token);
    localStorage.setItem('refreshToken', session.refresh_token);
  } else if (event === 'SIGNED_OUT') {
    console.log('User signed out, removing tokens');
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
  } else if (event === 'TOKEN_REFRESHED' && session) {
    console.log('Token refreshed, updating tokens');
    localStorage.setItem('token', session.access_token);
    localStorage.setItem('refreshToken', session.refresh_token);
  }
}); 